import { configurationKeys, UNBOUND_VALUE_TYPE } from "../../features/common/constants/configurationKeys";

export function resetCache(client) {
  const { cache } = client;

  const objectTypedQueries = configurationKeys.filter(z => z.type && z.type !== UNBOUND_VALUE_TYPE);
  Object.keys(cache.data.data).forEach(cacheKey => {
    const configKey = objectTypedQueries.find(z => cacheKey.match(z.type));
    if (configKey) {
      cache.data.delete(cacheKey);
      cache.evict({ id: "ROOT_QUERY", fieldName: configKey.query });
    }
  });

  /* Evict values that have no type directly from ROOT_QUERY */
  const singleValueQueries = configurationKeys.filter(z => z.type && z.type === UNBOUND_VALUE_TYPE);
  singleValueQueries.forEach(config => cache.evict({ id: "ROOT_QUERY", fieldName: config.query }));
}
